import React, { forwardRef } from 'react'
import { Icons } from 'material-table'

import {
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
  Columns3,
  Download,
  Filter,
  LucideIcon,
  Minus,
  Pencil,
  Plus,
  Search,
  Trash2,
  X,
} from 'lib/lucide'

const tableIcon = (Icon: LucideIcon) =>
  forwardRef<SVGSVGElement>((props, ref) => <Icon ref={ref} size={20} {...props} />)

const tableIcons: Icons = {
  Add: tableIcon(Plus),
  Check: tableIcon(Check),
  Clear: tableIcon(X),
  Delete: tableIcon(Trash2),
  DetailPanel: tableIcon(ChevronRight),
  Edit: tableIcon(Pencil),
  Export: tableIcon(Download),
  Filter: tableIcon(Filter),
  FirstPage: tableIcon(ChevronsLeft),
  LastPage: tableIcon(ChevronsRight),
  NextPage: tableIcon(ChevronRight),
  PreviousPage: tableIcon(ChevronLeft),
  ResetSearch: tableIcon(X),
  Search: tableIcon(Search),
  SortArrow: tableIcon(ChevronDown),
  ThirdStateCheck: tableIcon(Minus),
  ViewColumn: tableIcon(Columns3),
}

export { tableIcons }
